// ------------------------------------------------------------------------------
//      Enums
// ------------------------------------------------------------------------------
//
//      HEADS-UP: These have to be kept in sync with the PHP enums.

/**
 * The URL query keys for newsroom filter settings.
 */
export enum QueryKey {
    QUERY_TYPE = 'qt',
    QUERY_VALUE = 'qv',
    SEARCH_TERM = 'searchTerm',
    TAG = 'tag',
    QUICK_FILTER = 'quickFilter',
}

/**
 * The different filter types for filtering the newsroom index page.
 */
export enum QueryType {
    // noinspection JSUnusedGlobalSymbols
    TAG = 'tag',
    QUICK_FILTER = 'quick-filter',
    SEARCH_QUERY = 'search',
}

/**
 * The different quick filters that are used for the hero carousel,
 * and additionally for an explicit quick-filter selection through
 * the filter menu UI.
 */
export enum QuickFilter {
    PEOPLE_AND_CULTURE = 'quick-filter--people-and-culture',
    INVESTORS = 'quick-filter--investors',
    SUSTAINABILITY = 'quick-filter--sustainability',
    ALL = 'quick-filter--all',
}

/**
 * Keep synced to App\Enums\ArticleDisplayTypeEnum
 */
export enum DisplayType {
    NEWS_ARTICLE = 'News article',
    RED_ARTICLE = 'Red article',
    THOUGHT_LEADER = 'Thought leader',
}

/**
 * The article-filter interface that is compatible with the URL contract
 * for filtering the newsroom index page.
 */
export interface ArticleFilter {
    [QueryKey.QUERY_TYPE]: QueryType;
    [QueryKey.QUERY_VALUE]: string;
}

export interface ArticleDataInterface {
    type: 'article';
    id: number;
    title: string;
    publicationDate: string | {
        date: string;
    };
    hasImage: boolean;
    imageUrl: string | null;
    imageCaption: string | null;
    youtubeVideoId: string | null;
    url: string;
    upvoteCount: number;
    displayType: string;
    displayTypeSlug: string;
    contactPerson: {
        name: string;
        position: string;
    } | null;
    contactPersonAvatar: string | null;
    displayTitleOverImage: boolean;
}

export interface ArticleSectionDataInterface {
    type: 'article_section';
    id: number;
    displayType: string;
    displayTypeSlug: string;
    displayAfter: number;
    heading: string;
    publicationDate: string | {
        date: string;
    };
    contactPerson: {
        name: string;
        position: string;
    };
    articles: [
        ArticleDataInterface,
    ];
    contactPersonAvatar: string | null;
}

export interface VideoData {
    iframe: HTMLIFrameElement;
    target: YT.Player;
    shouldPlay: boolean;
}

export enum SpecialCardPositions {
    STAY_INFORMED = 7,
    ANY_QUESTIONS = 11,
    EVENTS = 4,
    FILTER_NEWSROOM = 13,
}

export const videoComponentTemplate = (id: string): string => `
    <iframe
        id="overview-youtube-video-${id}"
        class="article-card__video"
        style="opacity: 0;"
        src="https://www.youtube.com/embed/${id}?enablejsapi=1&controls=0&autohide=1&fs=0&showinfo=0&playlist=${id}&loop=1"
    >
    </iframe>
`
